import React from "react";
import styled from "styled-components";
const Styles = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  .text-field {
    width: calc(100% - 2rem);
    padding: calc(var(--fs-textfield) * 2.3) calc(1rem - 1px) calc(var(--fs-textfield) * 0.7);
    border-radius: var(--border-radius-2);
    border: 1px var(--n-grey-2) solid;
    outline: none;
    transition: var(--trans-1);
    font-size: var(--fs-textfield);
    &.error-text {
      border: 1px var(--secondry-1) solid;
    }
    &.ltr-text {
      direction: ltr;
      text-align: left;
    }
    &.disabled {
      background-color: var(--n-grey-01);
      color: var(--n-grey-5);
    }
    :focus {
      border: 1px var(--border-3) solid;
    }
  }
  .error {
    display: flex;
    height: 1rem;
    font-size: var(--fs-small);
    .icon {
      text-align: center;
      width: 1rem;
      height: 1rem;
    }
    .text {
      margin: 0 0.2rem 0 0;
    }
  }
  .label-textinput{
    z-index: 2;
    position: absolute;
    top: 1px;
    right: 1px;
    padding-right: 1rem;
    width: calc(100% - 2rem);
    padding-bottom: 0.5rem;
    padding-top: calc(var(--fs-textfield) * 0.5);;
    background-color: var(--n-grey-0);
    transition: var(--trans-1);
    font-size: calc(var(--fs-textfield) * 0.8);
    border-radius: var(--border-radius-2);
    &.disabled {
      background-color: var(--n-grey-01);
      color: var(--n-grey-5);
    }
  }
  
  @media screen and (max-width: 1445px) {
    .text-field {
      padding: calc(var(--fs-textfield) * 2.3) calc(1rem - 1px) calc(var(--fs-textfield) * 0.7);
    }
  }
`;

// dokme chesm baray ramz ha

export const TextInputBig = ({
  title = "",
  style,
  name,
  error,
  value,
  onchange,
  placeHolder,
  required,
  ltr,
  disabled = false
}) => {
  let errorComp = "";
  let classes = "text-field";
  if (error.toString()) {
    classes = "text-field error-text";
    errorComp = (
      <React.Fragment>
        <div className="icon">!</div>
        <div className="text">{error}</div>
      </React.Fragment>
    );
  }
  if (ltr) {
    classes += " ltr-text";
  }
  if (disabled) {
    classes += " disabled ";
  }
  return (
    <Styles>
      <textarea
        style={style}
        className={classes}
        value={value}
        name={name}
        placeholder={placeHolder}
        onChange={onchange}
        required={required}
        disabled={disabled}
        rows={5}
      ></textarea>
      <label className={"label-textinput " + ((disabled) ? " disabled " : "")}>
        {title}
      </label>
      <div className="error">{errorComp}</div>
    </Styles>
  );
};
